export default {
  sm: `
  첨단산업의 집약체<br>데이터센터 각 세종
  `,
};
